import { TYPEFORM_BOOK_URL } from '@/components/ItineraryPage/constants';

type SearchLike = { get: (key: string) => string | null };

/**
 * Builds the Typeform URL for "Book with advisor" (pancake menu + book-choice modal).
 * Mirrors post context from the current route when available.
 */
export function buildBookWithAdvisorTypeformUrl(pathname: string, searchParams: SearchLike): string {
  const postId =
    searchParams.get('postId') ||
    (pathname.startsWith('/post/') ? pathname.split('/post/')[1]?.split('?')[0] : null) ||
    (pathname.startsWith('/itinerary/') ? pathname.split('/itinerary/')[1]?.split('?')[0] : null) ||
    (pathname.startsWith('/list/') ? pathname.split('/list/')[1]?.split('?')[0] : null);

  let postTitle = '';
  if (typeof document !== 'undefined' && document.title) {
    postTitle = document.title.replace(/\s*-\s*Globe\s+Thrivers.*$/i, '').trim();
  }

  const params = new URLSearchParams();
  if (postId) {
    params.set('postId', postId);
  }
  if (postTitle) {
    params.set('postTitle', postTitle);
  }

  return `${TYPEFORM_BOOK_URL}${params.toString() ? `&${params.toString()}` : ''}`;
}
